import { SET_MODAL, SET_TAB, USER_INFO_FETCH_FAILED, USER_INFO_FETCH_SUCCEEDED } from '../constants'

export const userInfoFetchSucceeded = userInfo => ({
  type: USER_INFO_FETCH_SUCCEEDED,
  userInfo,
})
export const userInfoFetchFailed = error => ({
  type: USER_INFO_FETCH_FAILED,
  error,
})

export const setTab = tab => {
  return {
    type: SET_TAB,
    tab,
  }
}

export const setModal = modalText => {
  return {
    type: SET_MODAL,
    modalText,
  }
}
